import React from 'react'
import InstructorCard from '../../Reusable/InstructorCard'

const InstructorList = ({ instructors }) => {

    return (
        <section className="team-section team-page alternat-2">
            <div className="auto-container">
                <div className="row clearfix">
                    {
                        instructors.map((instructor) => {
                            return (
                                <InstructorCard key={instructors.id} instructor={instructor} />
                            )
                        })
                    }
                </div>
            </div>
        </section>

    )
}

export default InstructorList